import "./styles.scss";
import { ContactUs } from "../../js/contact-us";

new ContactUs();
